import { CustomButton } from "../global/CustomButton"
import { useNavigate } from "react-router-dom"
import "./cartTotal.css"

export function CartTotal({ cartClone, subtotal }) {
    const navigate = useNavigate()

    return (
        <div className="d-flex justify-content-between total-section mt-5 lg-row">

            <div className="d-flex align-items-start gap-3 coupon-code">
                <input type="text" placeholder="Coupon Code" />
                <CustomButton
                    color="primary"
                    text="Apply Coupon"
                />
            </div>

            <div className="cart-total p-4">
                <h4 className="mb-3">Cart Total</h4>
                <div className="d-flex justify-content-between border-bottom-sections">
                    <p>Subtotal :</p>
                    <p>${parseFloat(subtotal.toPrecision(6))}</p>
                </div>
                <div className="d-flex justify-content-between border-bottom-sections mt-3">
                    <p>Shipping :</p>
                    <p>Free</p>
                </div>
                <div className="d-flex justify-content-between mt-3">
                    <p>Total :</p>
                    <p>${parseFloat(subtotal.toPrecision(6))}</p>
                </div>

                <div className="d-flex justify-content-center">
                    <CustomButton
                        color="primary"
                        text="Proceed to checkout"
                        btnFunction={() => {
                            navigate("/cart/checkout", {
                                state: {
                                    fromCart: true,
                                    cartClone,
                                    subtotal
                                }
                            })
                        }}
                    />
                </div>

            </div>
        </div>
    )
}